/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import { getNEUserMapping } from 'api/pgads.js'
import CommonScreen from '../CommonScreen'

const headers = [
  strCol({
    ident: 'neUser',
    display: 'NE User Id',
    width: 400,
    isKey: true,
    sortOrder: 'asc',
  }),

  strCol({
    ident: 'gadsUser',
    display: 'GADS User Id',
    isKey: true,
    width: 400,
    sortOrder: 'asc',
  }),

  modifierCol,
  modifiedDateCol,
]

const title = 'ISO-NE Users Mapping'

const NEUsers = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  return (
    <CommonScreen
      title={title}
      header={headers}
      saveTask={getNEUserMapping}
      retrieveTask={getNEUserMapping}
      deleteTask={getNEUserMapping}
      autoRetrieve
      sortOptions={headers}
      totalWidth={1200}
      insertComp={insertEvent}
      insertCompHeight={150}
      onInsertEvent={_ => setInsertEvent(false)}
      withDelete={false}
      withoutModify
      allowInsert={false}
    />
  )
}
const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(NEUsers)
